import { getAuthorizationToken }          from 'services/authorization_token';
import { ASSETS_DOMAIN, ASSETS_PROTOCOL } from 'constants/application_constants';
import { openLinkOrDownloadFile }         from 'services/file';

export const getActivitiesPDF = contractRequestId => new Promise((resolve) => {
  const path = `${ ASSETS_PROTOCOL }://${ ASSETS_DOMAIN }/pdfs/contract_requests/${ contractRequestId }/activities.pdf?authorization_token=${ getAuthorizationToken() }`;
  resolve(openLinkOrDownloadFile(path, 'activities.pdf'));
});
